import React from 'react';
import { Users, Plus, Edit, Trash2 } from 'lucide-react';

export default function PositionTab({
  positions,
  departments,
  subDivisions,
  roles,
  salaryGrades,
  onAdd,
  onEdit,
  onDelete,
}) {
  const getDepartmentName = deptId => departments.find(d => d.id === deptId)?.name || '-';

  return (
    <div className="bg-white rounded-lg border shadow-sm">
      <div className="p-4 border-b flex items-center justify-between">
        <h3 className="font-semibold flex items-center gap-2">
          <Users className="w-5 h-5" />
          Jabatan
        </h3>
        <button
          onClick={onAdd}
          className="bg-emerald-600 hover:bg-emerald-700 text-white px-3 py-1.5 rounded-md text-sm font-medium flex items-center"
        >
          <Plus className="w-4 h-4 mr-1" /> Tambah
        </button>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-gray-50 border-b">
              <th className="text-left px-4 py-3 text-sm font-medium text-gray-700">Kode</th>
              <th className="text-left px-4 py-3 text-sm font-medium text-gray-700">
                Nama Jabatan
              </th>
              <th className="text-left px-4 py-3 text-sm font-medium text-gray-700 hidden md:table-cell">
                Level
              </th>
              <th className="text-left px-4 py-3 text-sm font-medium text-gray-700 hidden lg:table-cell">
                Divisi
              </th>
              <th className="text-left px-4 py-3 text-sm font-medium text-gray-700">Status</th>
              <th className="text-right px-4 py-3 text-sm font-medium text-gray-700">Aksi</th>
            </tr>
          </thead>
          <tbody>
            {positions.length === 0 ? (
              <tr>
                <td colSpan={6} className="text-center py-8 text-gray-500">
                  Tidak ada data
                </td>
              </tr>
            ) : (
              positions.map(item => (
                <tr key={item.id} className="border-b hover:bg-gray-50">
                  <td className="px-4 py-3 font-medium">{item.code}</td>
                  <td className="px-4 py-3">{item.name}</td>
                  <td className="px-4 py-3 hidden md:table-cell">
                    <span className="px-2 py-1 text-xs font-medium rounded-full border">
                      {item.level}
                    </span>
                  </td>
                  <td className="px-4 py-3 hidden lg:table-cell">
                    {getDepartmentName(item.department_id)}
                  </td>
                  <td className="px-4 py-3">
                    <span
                      className={`px-2 py-1 text-xs font-medium rounded-full ${item.status === 'active' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-700'}`}
                    >
                      {item.status === 'active' ? 'Aktif' : 'Tidak Aktif'}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-right">
                    <div className="flex justify-end gap-1">
                      <button
                        onClick={() => onEdit(item)}
                        className="p-2 hover:bg-gray-100 rounded-lg"
                      >
                        <Edit className="w-4 h-4" />
                      </button>
                      <button
                        onClick={() => onDelete(item.id)}
                        className="p-2 hover:bg-gray-100 rounded-lg"
                      >
                        <Trash2 className="w-4 h-4 text-red-500" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
